import { UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_0, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_1, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_2, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_3, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_4, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_5, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_6, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_7, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_8, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_9, UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_10, UPRIGHT_TO_MOUNTING_RAIL_600, UPRIGHT_TO_MOUNTING_RAIL_800 } from '@inter-ikea-storagetwo/boaxel/dist/constants/connectorKeys';
import { getConnectorsComponent } from '@inter-ikea-storagetwo/range/dist/functions/componentGetters';
export const getConnectionByKey = (entity, key) => {
    const connector = getConnectorsComponent(entity).getConnectorByKey(key);
    if (!connector)
        throw new Error(`Unable to get connector (${key}) for entity: ${entity.id}`);
    return connector;
};
export const CONNECTOR_TO_SIZE_MAP = new Map([
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_0, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_1, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_2, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_3, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_4, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_5, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_6, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_7, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_8, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_9, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_ADJUSTABLE_10, 200],
    [UPRIGHT_TO_MOUNTING_RAIL_600, 600],
    [UPRIGHT_TO_MOUNTING_RAIL_800, 800]
]);
//# sourceMappingURL=connectorUtils.js.map